import React from 'react';
import { connect } from 'react-redux';
import { removeHtmlTags } from '../../utilities/methods';

import Label from '../Labels/Label';
import AccordionLabel from '../Accordion/Label';
import Accordion from '../Accordion/Accordion';

import "./Room.css";

const ScenarioInfo = ({ isRoomHost, tasks }) => {
    if (Object.keys(tasks).length === 0) {
        return null;
    }

    const areaName = removeHtmlTags(tasks.areaName);
    const descricao = removeHtmlTags(tasks.descricao);
    const tarefas = removeHtmlTags(tasks.tarefas);
    const orientacoes = removeHtmlTags(tasks.orientacoes);

    return (
        <div className='col-md-12 mt-2'>
            <Accordion>
                <Accordion.Item>
                    <Accordion.Header>
                        <div className='scenario_label'>
                            <AccordionLabel
                                text={`AVALIAÇÃO DE HABILIDADES CLÍNICAS - ${areaName}`}
                                className="scenario_label_paragraph"
                            />
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className='col-md-12'>
                            <Label text="CENÁRIO DE ATUAÇÃO" />
                            <small className='scenario_paragraph'>{descricao}</small>
                        </div>

                        <div className='col-md-12'>
                            <Label text="SUAS TAREFAS" />
                            <small className='scenario_paragraph'>{tarefas}</small>
                        </div>

                        {
                            isRoomHost && (<div className='col-md-12'>
                                <Label text="ORIENTAÇÕES" />
                                <small className='scenario_paragraph'>{orientacoes}</small>
                            </div>)
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ScenarioInfo);